import { render, staticRenderFns } from "./Errormsg.html?vue&type=template&id=1c019610&scoped=true&"
import script from "./Errormsg.vue?vue&type=script&lang=js&"
export * from "./Errormsg.vue?vue&type=script&lang=js&"
import style0 from "./Errormsg.scss?vue&type=style&index=0&id=1c019610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c019610",
  null
  
)

export default component.exports